@if (placeholder) {
  <span
    class="chart-placeholder"
    [style.width.px]="width || 236"
    [style.height.px]="height || 236"
  >
    <span
      class="chart-placeholder-ring"
      [style.width.px]="placeholderRingSize"
      [style.height.px]="placeholderRingSize"
      [style.margin-top.px]="placeholderRingOffset"
    >
      <span
        class="chart-placeholder-hole"
        [style.width.%]="innerWidth || 55"
        [style.height.%]="innerWidth || 55"
      ></span>
    </span>
  </span>
  @if (showLegend) {
    <ea-charts-legend
      [placeholder]="true"
      [showValues]="showLegendValues"
    ></ea-charts-legend>
  }
} @else {
  @if (_options && _options.series) {
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="_options"
      [ngStyle]="{ display: 'block' }"
      [style.height.px]="height || 236"
      [style.min-width.px]="width || 236"
      [style.mask-image]="sweepMask"
    ></highcharts-chart>
  }
  @if (showLegend && _options && _options.series && _options.series[0]) {
    <ea-charts-legend
      [isRedirect]="isRedirect"
      [animated]="animated"
      [options]="_options"
      [series]="_options.series[0].data"
      [showValues]="showLegendValues"
      [unity]="unity"
    ></ea-charts-legend>
  }
}
